import { DynamicElementsMap } from '../models';
import { GroupItemComponent, GroupItemsMap } from './group';
import { SingleItemComponent, SingleItemsMap } from './single-items-map';

export type ItemComponent = SingleItemComponent | GroupItemComponent;

export const ItemsMap: DynamicElementsMap = {
  ...SingleItemsMap,
  ...GroupItemsMap,
};
